import { getTotalForestArea } from "./utils";

const calculateDiscountAmount = (couponDiscount) =>
  couponDiscount?.coupon_discount_price || 0;

export const calculatePrices = ({
  properties,
  couponDiscount,
  hasDfr
}) => {
  const hasErrors = properties.some((prop) => prop.plus_price_error);

  if (hasErrors || !properties?.length) {
    return {
      totalForestArea: 0,
      propertiesTotalPrice: 0,
      discountAmount: 0,
      discountedPrice: 0,
      propertiesHectarePrice: 0,
    };
  }

  const totalForestArea = getTotalForestArea(properties);

  let propertiesTotalPrice = 0
  let MultiPlusDiscount = undefined
  //Ugly fix to show 15% discount for multiple properties or already has DFR
  if (properties.length > 1 || hasDfr) {
    propertiesTotalPrice = properties.reduce(
      (acum, prop) => acum + (prop.plus_price * 0.85),
      0
    );

    const multiPlusDiscountAmount = properties.reduce(
      (acum, prop) => acum + (prop.plus_price * 0.15),
      0
    );

    MultiPlusDiscount = {
      "discountAmount": multiPlusDiscountAmount,
      "discountReason": properties.length > 1 ? "Rabatt vid köp av flera fastigheter (15%)" : "Rabatt som Plusmedlem (15%)"
    };

  } else {
    propertiesTotalPrice = properties.reduce(
      (acum, prop) => acum + prop.plus_price,
      0
    );
  }

  const propertiesHectarePrice = propertiesTotalPrice / totalForestArea ?? 0;

  const discountAmount = calculateDiscountAmount(couponDiscount);
  const discountedPrice = Math.max(propertiesTotalPrice - discountAmount, 0);

  return {
    totalForestArea,
    propertiesTotalPrice: propertiesTotalPrice,
    discountAmount,
    discountedPrice,
    propertiesHectarePrice,
    MultiPlusDiscount
  };
};
